let videoAbortController = new AbortController(); // Global abort controller
let productVideos = {};

if (typeof productVideosList === "string") {
  try {
    productVideos = JSON.parse(productVideosList);
  } catch (error) {
    console.error("Invalid JSON string:", productVideosList, error);
  }
} else if (productVideosList && typeof productVideosList === "object" && !Array.isArray(productVideosList)) {
  productVideos = productVideosList;
}

if (!productVideos || typeof productVideos !== "object" || Array.isArray(productVideos)) {
  productVideos = {};
}

document.addEventListener("DOMContentLoaded", function () {
  const videoElement = document.getElementById("product-video");
  const loader = document.getElementById("video-loader");
  const videoNotFound = document.getElementById("video-not-found");

  function setDisplay(element, value) {
    if (element) {
      element.style.display = value;
    }
  }

  let isDragging = false;
  let startX = 0;
  let startTime = 0;
  let wasPlaying = false;
  let lastUpdateTime = 0;
  const sensitivity = {
    desktop: 0.05, // Sensitivity for mouse
    mobile: 0.08, // Adjusted for smoother mobile dragging
  };
  const debounceInterval = 16; // ~60fps (16ms per frame)

  if (videoElement) {
    videoElement.controls = false; // Hide default controls

    // Ensure video metadata is loaded before dragging
    videoElement.addEventListener("loadedmetadata", () => {
      if (!videoElement.duration) {
        console.warn("Video duration not available");
      }
    });

    // Mouse Events
    videoElement.addEventListener("mousedown", startDragging);
    window.addEventListener("mousemove", handleDragging, { passive: false });
    window.addEventListener("mouseup", stopDragging);

    // Touch Events
    videoElement.addEventListener("touchstart", startDragging, {
      passive: false,
    });
    window.addEventListener("touchmove", handleDragging, { passive: false });
    window.addEventListener("touchend", stopDragging);

    // Start Dragging (Mouse or Touch)
    function startDragging(event) {
      if (videoElement.duration === 0 || isNaN(videoElement.duration)) {
        return; // Prevent dragging until metadata is loaded
      }
      isDragging = true;
      startX =
        event.type === "touchstart" ? event.touches[0].clientX : event.clientX;
      startTime = videoElement.currentTime;
      wasPlaying = !videoElement.paused;

      videoElement.pause(); // Pause immediately on drag
      event.preventDefault(); // Prevent scrolling/zooming
      document.body.style.cursor =
        event.type === "mousedown" ? "grab" : "default";
    }

    // Handle Dragging (Mouse or Touch)
    function handleDragging(event) {
      if (!isDragging) return;

      const now = performance.now();
      if (now - lastUpdateTime < debounceInterval) {
        return; // Skip if too soon
      }
      lastUpdateTime = now;

      const clientX =
        event.type === "touchmove" ? event.touches[0].clientX : event.clientX;
      const deltaX = clientX - startX;
      const currentSensitivity =
        event.type === "touchmove" ? sensitivity.mobile : sensitivity.desktop;
      const newTime = startTime + deltaX * currentSensitivity;

      // Update video time within bounds
      requestAnimationFrame(() => {
        if (isDragging) {
          videoElement.currentTime = Math.max(
            0,
            Math.min(newTime, videoElement.duration)
          );
        }
      });

      event.preventDefault(); // Prevent scrolling/zooming on touch
    }

    // Stop Dragging (Mouse or Touch)
    function stopDragging() {
      if (!isDragging) return;

      isDragging = false;
      document.body.style.cursor = "default";

      if (wasPlaying) {
        videoElement.play().catch((error) => {
          console.error("Error resuming video:", error);
        });
      }
    }

    // Prevent default touch behavior on video element
    videoElement.addEventListener(
      "touchstart",
      (event) => {
        event.stopPropagation();
      },
      { passive: false }
    );
  }

  // Function to get URL parameters
  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  // Function to find the variant by ID
  function findVariantById(variantId) {
    return productVariants.find((variant) => variant.id == variantId);
  }

  // Function to construct the video key based on variant options
  function getVideoKey(variant) {
    const index = variant.option1.split(" ").length > 1 ? 1 : 0;
    let result = `${variant.option1.split(" ")[index].toLowerCase()}${variant.option2 ? variant.option2.toLowerCase() : ""
      }`;

    if (result.includes("platinum")) {
      result = result.replace("platinum", "white");
    }

    return result;
  }

  function updateProductVideo(videoUrl) {
    const videoContainer = document.getElementById("video-container");
    const video360Icon = document.getElementById("video-360-icon");
    if (!videoElement || !videoUrl) {
      handleInvalidVideo();
      return;
    }

    videoAbortController.abort();
    videoAbortController = new AbortController();

    videoElement.style.opacity = '0';

    const tempVideo = document.createElement("video");
    tempVideo.src = videoUrl;

    tempVideo.onloadeddata = function () {
      if (videoContainer.style.display === 'none' || getComputedStyle(videoContainer).display === 'none') {
        videoContainer.style.opacity = '0';
        videoContainer.style.display = 'block';
      }
      const videoSource = videoElement.querySelector("source");
      videoSource.src = videoUrl;
      videoElement.load();

      videoElement.oncanplay = function () {
        requestAnimationFrame(() => {
          videoContainer.style.opacity = '1';
          videoElement.style.opacity = '1';
        });
        setDisplay(video360Icon, "block");
        videoElement.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      };
    };

    tempVideo.onerror = function () {
      handleInvalidVideo();
    };

    function handleInvalidVideo() {
      if (videoContainer) {
        videoContainer.style.opacity = '0';
        setTimeout(() => { setDisplay(videoContainer, "none"); }, 360);
      }
      console.error("Invalid or unsupported video:", videoUrl);
    }
  }

  // Function to handle variant change
  function handleVariantChange() {
    const videoContainer = document.getElementById("video-container");
    setDisplay(videoNotFound, "none");
    const variantId = getUrlParameter("variant");
    let selectedVariant = variantId
      ? findVariantById(variantId)
      : productVariants[0];

    if (selectedVariant) {
      const videoKey = getVideoKey(selectedVariant);
      const videoUrl = Object.prototype.hasOwnProperty.call(productVideos, videoKey)
        ? productVideos[videoKey]
        : null;
      // Exposed so other scripts (e.g. the ring-builder "Complete Your Ring"
      // handler) can read the current variant's video URL synchronously,
      // without waiting on the <source> element's async load below — that
      // element's src is only set once the hidden preload video fires
      // loadeddata, which can be well after a shopper clicks through.
      window.currentProductVideoUrl = videoUrl || null;
      if (videoUrl) {
        updateProductVideo(videoUrl);
      } else {
        if (videoContainer && videoContainer.style.display !== 'none') {
          videoContainer.style.opacity = '0';
          setTimeout(() => { setDisplay(videoContainer, "none"); }, 360);
        } else {
          setDisplay(videoContainer, "none");
        }
        setDisplay(videoNotFound, "flex");
      }
    }
  }

  // Initial video setup
  handleVariantChange();

  // Listen for URL changes (back/forward navigation)
  if (!window.historyPatchedForVideo) {
    const originalPushState = history.pushState;
    history.pushState = function () {
      originalPushState.apply(this, arguments);
      window.dispatchEvent(new Event('varianturlchangevid'));
    };

    const originalReplaceState = history.replaceState;
    history.replaceState = function () {
      originalReplaceState.apply(this, arguments);
      window.dispatchEvent(new Event('varianturlchangevid'));
    };
    window.historyPatchedForVideo = true;
  }

  let lastVariantId = getUrlParameter("variant");

  const checkVariantChange = () => {
    const currentVariantId = getUrlParameter('variant');
    if (currentVariantId !== lastVariantId) {
      lastVariantId = currentVariantId;
      handleVariantChange();
    }
  };

  window.addEventListener('varianturlchangevid', checkVariantChange);
  window.addEventListener('popstate', checkVariantChange);

  document.addEventListener('click', () => {
    setTimeout(checkVariantChange, 50);
  });

  // Use targeted MutationObserver — NOT on whole document to avoid spurious variant reloads
  const variantSelectsVid = document.querySelectorAll('select[name="id"], input[name="id"], .variant-input, [data-variant-id]');
  const observer = new MutationObserver(checkVariantChange);
  if (variantSelectsVid.length > 0) {
    variantSelectsVid.forEach(el => observer.observe(el, { attributes: true, attributeFilter: ['value', 'class', 'checked'] }));
  } else {
    const swatchesVid = document.querySelectorAll('.swatch, .variant-swatch, [data-option], .color-swatch, .size-option');
    if (swatchesVid.length > 0) {
      swatchesVid.forEach(el => observer.observe(el, { attributes: true, attributeFilter: ['class'] }));
    }
  }

  // Cleanup event listeners on page unload
  window.addEventListener("pagehide", () => {
    window.removeEventListener("mousemove", handleDragging);
    window.removeEventListener("mouseup", stopDragging);
    window.removeEventListener("touchmove", handleDragging);
    window.removeEventListener("touchend", stopDragging);
    window.removeEventListener("popstate", handleVariantChange);
  });
});
